<div class="content-wrapper">
  <router-outlet></router-outlet>
</div>
